import { UserDetailsContext } from "App";
import { redirectToPage } from "app/common/redirects/Redirects";
import {
  IAM_FRONT_END_URL,
  IMAGE_URL,
  PRODUCT_ID,
} from "common-ui-components/components/utils/Config";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import { links } from "HelpLinks";
import ProfileImageEdit from "./ProfileImageEdit";
import profileIcon from "./../icons/profile.svg";
import tickIcon from "./../../TickMark.svg";
import styles from "./../Root.module.css";
import { logOut } from "../Root";

const ProfileImage = () => {
  const ProfileDropdownPortal = ({ children }) => {
    return createPortal(children, document.body);
  };

  const userDetails = useContext(UserDetailsContext);
  const location = useLocation();
  const history = useNavigate();

  //profile dropdown styles and functionality

  //check whether the route is in try product for controlling the profile dropdown content
  const isTryProductPath = location.pathname.includes("/try-product");

  //for setting logo, favicon and profile image at rendering
  const photoUpdatedAt = userDetails.photoUpdatedAt ?? undefined;
  const photoKey = userDetails.photoKey ?? undefined;
  const photoUrl =
    photoUpdatedAt && photoUpdatedAt !== ""
      ? `${IMAGE_URL}?type=photo&v=${photoUpdatedAt}&key=${photoKey}&productId=${PRODUCT_ID}`
      : profileIcon;

  const [verified, setVerified] = useState(userDetails.verified || false);

  //profiledata creation and updation on userdetails change
  const [profileData, setProfileData] = useState({
    name: userDetails.name || "",
    email: userDetails.email || "",
    roleName: userDetails.roleName || "",
  });

  useEffect(() => {
    setProfileData({
      name: userDetails.name || userDetails.username || "",
      email: userDetails.email || "",
      roleName: userDetails.roleName || userDetails.role || "",
    });
    setVerified(userDetails.verified || false);
  }, [userDetails]);

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: "60px",
    left: "auto",
    right: "10px",
  });
  const [profileDropdown, setProfileDropdown] = useState(false);
  const dropdownStyle = {
    position: "absolute",
    top: dropdownPosition.top,
    left: dropdownPosition.left,
    right: dropdownPosition.right,
    background: "#fff",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    borderRadius: "5px",
    width: "270px",
    zIndex: 3000,
    padding: "10px 10px",
  };

  const handleProfileClick = (event) => {
    event.stopPropagation();
    setProfileDropdown((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      )
        setProfileDropdown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    if (profileDropdown && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: `${rect.bottom + window.scrollY + 13}px`,
        left: `${rect.right - 270 + window.scrollX + 2}px`,
        right: "auto",
      });
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileDropdown]);

  //Redirection functions for profile dropdown
  const redirectToChangePassword = () => {
    const iamServer = IAM_FRONT_END_URL + "/auth";
    const redirectUrl = `${iamServer}/changePassword`;
    window.location.href = redirectUrl;
  };
  const redirectToAccount = () => {
    redirectToPage(history, "/app/settings/account/personalization");
  };
  const redirectToPayments = () => {
    redirectToPage(history, "/app/settings/account/subscription");
  };
  
  const dropdownMenuItems = [
    {
      key: "help",
      label: "Help",
      borderTop: true,
      onClick: () => window.open(links.help, "_blank"),
    },
    {
      key: "faq",
      label: "FAQ",
      onClick: () => window.open(links.faq, "_blank"),
    },
    {
      key: "personalization",
      label: "Personalization",
      borderTop: true,
      hideOnTryProduct: true,
      onClick: redirectToAccount,
    },
    {
      key: "changePassword",
      label: "Change Password",
      hideOnTryProduct: true,
      onClick: redirectToChangePassword,
    },
    {
      key: "subscription",
      label: "Subscription",
      hideOnTryProduct: true,
      onClick: redirectToPayments,
    },
    {
      key: "support",
      label: "Support",
      onClick: () => window.open(links.support, "_blank"),
    },
    {
      key: "logout",
      label: "Log out",
      borderTop: true,
      onClick: logOut,
    },
  ];

  return (
    <div className={styles.controls}>
      {(() => {
        if ("profilePicture" in userDetails) {
          if (userDetails.profilePicture)
            return (
              <img
                className={styles.profileImg}
                src={userDetails.profilePicture}
                alt="Photo"
                onClick={handleProfileClick}
                ref={buttonRef}
              />
            );
          else
            return (
              <img
                className={styles.profileImg}
                src={profileIcon}
                alt="Photo"
                onClick={handleProfileClick}
                ref={buttonRef}
              />
            );
        }
        return (
          <img
            className={styles.profileImg}
            src={photoUrl}
            alt="Photo"
            onClick={handleProfileClick}
            ref={buttonRef}
          />
        );
      })()}

      {profileDropdown && (
        <ProfileDropdownPortal>
          <div
            ref={dropdownRef}
            style={dropdownStyle}
            className={styles.profileCard}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "15px",
              }}
            >
              <ProfileImageEdit />

              <div style={{ display: "grid", gap: "1px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <b
                    style={{
                      fontSize: "16px",
                      color: "#344054",
                      marginBottom: "0.3rem",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "block",
                      maxWidth: "150px",
                    }}
                    title={profileData.name}
                  >
                    {profileData.name}
                  </b>
                  {verified && (
                    <img
                      src={tickIcon}
                      width={"15px"}
                      height={"15px"}
                      alt="tick"
                    />
                  )}
                </div>
                <b
                  style={{
                    fontSize: "medium",
                    color: "#667085",
                    marginBottom: "0.3rem",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "block",
                    maxWidth: "170px",
                  }}
                  title={profileData.email}
                >
                  {profileData.email}
                </b>
                <div className={styles.role}>{profileData.roleName}</div>
              </div>
            </div>

            <div style={{ display: "grid", marginTop: "10px" }}>
              {dropdownMenuItems
                .filter((item) => !item.hideOnTryProduct || !isTryProductPath)
                .map((item) => (
                  <div
                    key={item.key}
                    style={
                      item.borderTop
                        ? { borderTop: "1.5px solid #f0f0f0" }
                        : undefined
                    }
                    className={styles.list}
                    onClick={item.onClick}
                  >
                    {item.label}
                  </div>
                ))}
            </div>
          </div>
        </ProfileDropdownPortal>
      )}
    </div>
  );
};

export default ProfileImage;